import { moveToFulfilled, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  AddGroupLeaderFulfilledAction,
  RemoveGroupLeaderFulfilledAction,
} from '../../domains/groupAddRemoveLeader/action.types';
import { GroupRemoveUserFulfilledAction } from '../../domains/groupAddRemoveUser/actions.types';
import { GroupRevokeAdminFulfilledAction } from '../../domains/groupMakeRevokeAdmin/actions.types';
import { GroupSidebarLoadFulfilledAction } from '../../domains/groupSidebarLoad/actions.types';
import { GroupMembersEdge } from '../types';

import { GroupsLeaders } from './types';

export type GroupLeadersAction =
  | GroupSidebarLoadFulfilledAction
  | AddGroupLeaderFulfilledAction
  | RemoveGroupLeaderFulfilledAction
  | GroupRevokeAdminFulfilledAction
  | GroupRemoveUserFulfilledAction;

const initialState: GroupsLeaders = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const addLeader = (state: GroupsLeaders, { groupId, userId }: AddGroupLeaderFulfilledAction['payload']) => {
  const groupLeaders = state.fulfilled.byId[groupId];

  return groupLeaders
    ? update(state, groupId, {
        ...groupLeaders,
        leaders: [
          ...groupLeaders.leaders,
          {
            nodeId: userId,
            isAdmin: true,
          },
        ],
      })
    : state;
};

const removeLeader = (state: GroupsLeaders, { groupId, userId }: RemoveGroupLeaderFulfilledAction['payload']) => {
  const groupLeaders = state.fulfilled.byId[groupId];

  return groupLeaders
    ? update(state, groupId, {
        ...groupLeaders,
        leaders: groupLeaders.leaders.filter((leader: GroupMembersEdge) => leader.nodeId !== userId),
      })
    : state;
};

const reducer: Reducer<GroupsLeaders, GroupLeadersAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_SIDEBAR.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupLeaders);
    case 'GROUP.ADD_LEADER_FULFILLED':
      return addLeader(state, action.payload);
    case 'GROUP.REMOVE_LEADER_FULFILLED':
    case 'GROUP.REVOKE_ADMIN_FULFILLED':
    case 'GROUP.REMOVE_USER_FULFILLED':
      return removeLeader(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
